export let OriginApp = /*#__PURE__*/function (OriginApp) {
  OriginApp["ADI"] = "ADI";
  OriginApp["Editor"] = "Editor";
  OriginApp["StudioEditor"] = "StudioEditor";
  OriginApp["Studio2Editor"] = "Studio2Editor";
  OriginApp["Editor3"] = "Editor3";
  OriginApp["Blocks"] = "Blocks";
  OriginApp["BusinessManager"] = "BusinessManager";
  OriginApp["IntroFunnel"] = "IntroFunnel";
  OriginApp["TemplatesGallery"] = "TemplatesGallery";
  OriginApp["TemplatesViewer"] = "TemplatesViewer";
  OriginApp["PackagePicker"] = "PackagePicker";
  OriginApp["AcceptPayments"] = "AcceptPayments";
  OriginApp["WixPayments"] = "WixPayments";
  OriginApp["Hopp"] = "Hopp";
  OriginApp["AccountManager"] = "AccountManager";
  OriginApp["SitesList"] = "SitesList";
  OriginApp["Landing"] = "Landing";
  OriginApp["Contact"] = "Contact";
  OriginApp["test"] = "test";
  OriginApp["USP"] = "USP";
  return OriginApp;
}({});
// kb-server editor values; origins without an entry resolve to the article linked to "ALL" editors.
export const KB_EDITOR_TYPE_BY_ORIGIN = {
  Editor: 'EDITOR',
  Editor3: 'EDITOR_3',
  StudioEditor: 'STUDIO',
  Studio2Editor: 'STUDIO_2'
};
//# sourceMappingURL=origin.js.map